import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postTravelSixSlice = createSlice({
  name: "postTravelSix",
  initialState,
  reducers: {
    postTravelSixStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postTravelSixSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postTravelSixFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postTravelSixStart,
  postTravelSixSuccess,
  postTravelSixFailure,
  clearError,
  clearMessage,
} = postTravelSixSlice.actions;

export default postTravelSixSlice.reducer;
